import { I18nModule } from '@spartacus/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrBrowsingComponent } from './kn-br-browsing.component';



@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        KnBrBrowsingComponent
    ],
    exports: [KnBrBrowsingComponent]
})
export class KnBrBrowsingModule { }
